import axios from 'axios';
/* eslint-disable no-undef */
export const LeadboxHeader = {
  props: ['useAdobe', 'dealerCode','manufacturer', 'pageName', 'channel', 'hier', 'pageNoName', 'lang', 'showTotal'],
  data() {
    return {
      useFordAdobe: (this.useAdobe ? this.useAdobe : false),
      fordDealerCode: (this.dealerCode ? this.dealerCode : ''),
      adobePageName: (this.pageName ? this.pageName : ''),
      adobeChannel: (this.channel ? this.channel : ''),
      adobeHier: (this.hier ? this.hier : ''),
      adobePageNoName: (this.pageNoName ? this.pageNoName : ''),
      adobeLanguage: (this.lang ? this.lang : ''),
      dealerManufacturer: (this.manufacturer ? this.manufacturer : ''),
      totalInventory: '',
    }
  },
  mounted(){
    if(this.showTotal){
      this.getTotalInventory();
    }

      const checkIfMobile = () => {
        return window.innerWidth < 1280;
      };

      const setupMutationObserver = () => {
        if (document.querySelector('header.lbsticky')) {

            const burgerButton = document.querySelector('.header-burger-btn');

            if (burgerButton) {

                const checkActiveClass = () => {
                    if (burgerButton.classList.contains('active')) {
                        document.body.style.overflow = 'hidden';
                        document.querySelector('.mobile-nav').classList.remove('h-full');
                        document.getElementById('header-mm').classList.add('menu-sticky-scroll');
                    } else {
                        document.body.style.overflowX = 'hidden';
                        document.body.style.overflowY = 'auto';
                        document.querySelector('.mobile-nav').classList.add('h-full');
                        document.getElementById('header-mm').classList.remove('menu-sticky-scroll');
                    }
                };

                const observer = new MutationObserver((mutationsList) => {
                    for (let mutation of mutationsList) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            checkActiveClass();
                        }
                    }
                });

                observer.observe(burgerButton, {
                    attributes: true
                });

                checkActiveClass();
            }
        }
      };

      if (checkIfMobile()) {
        setupMutationObserver();
      }

      window.addEventListener('resize', () => {
        if (checkIfMobile()) {
            setupMutationObserver();
        }
      });
  },
  methods: {

    phoneClick(site, type) {

      var payload = {"event_category":"LBX-Phone", "event_label":'LBX-' + site + '-' + type};
      window.sendGAEvent("LBX-PhoneNumber-Click",payload);

      if (this.useFordAdobe && this.fordDealerCode) {
        digitaldata.onclick = digitaldata.onclick || {};
        digitaldata.page = digitaldata.page || {};
        digitaldata.vehicle = digitaldata.vehicle || {};
        digitaldata.user = digitaldata.user || {};
        digitaldata.event = digitaldata.event || {};
        digitaldata.page.pageName = this.adobePageName;
        digitaldata.page.siteSection = this.adobeChannel;
        digitaldata.page.hierarchy = this.adobeHier;
        digitaldata.page.userLanguage = this.adobeLanguage;
        digitaldata.page.pageNameNoVehicle = this.adobePageNoName;
        digitaldata.page.client =  this.dealerManufacturer;
        digitaldata.page.site = "dc:leadbox:ca";
        digitaldata.page.tool = "event:click to call";
        digitaldata.page.toolDescriptor = "click to call:global";
        digitaldata.page.radUIVersion = window.innerWidth < 768 ? 'ui:rad:mobile' : window.innerWidth < 992 ? 'ui:rad:tablet' : 'ui:rad:pc';
        digitaldata.onclick.onclick = "help:click to call:" + type.toLowerCase();
        digitaldata.onclick.onclickLinkName = "dc:help:click to call";
        digitaldata.event.action = "click to call|tool";
        digitaldata.user.paCode = this.fordDealerCode;
        typeof (_satellite) !== "undefined" ? _satellite.track("click-to-call") : (function () { console.warn("'_satellite' is not defined"); return null; })();
      }
      else {
        console.warn("Ford Adobe Disabled");
      }
    },
    addressClick(site) {
      var payload = {'event_category': 'LBX-Address', 'event_label': 'LBX-' + site};
      window.sendGAEvent("LBX-Address-Click", payload);
    
      if (this.useFordAdobe && this.fordDealerCode) {
        digitaldata.onclick = digitaldata.onclick || {};
        digitaldata.page = digitaldata.page || {};
        digitaldata.vehicle = digitaldata.vehicle || {};
        digitaldata.user = digitaldata.user || {};
        digitaldata.event = digitaldata.event || {};
        digitaldata.page.pageName = this.adobePageName;
        digitaldata.page.siteSection = this.adobeChannel;
        digitaldata.page.hierarchy = this.adobeHier;
        digitaldata.page.userLanguage = this.adobeLanguage;
        digitaldata.page.pageNameNoVehicle = this.adobePageNoName;
        digitaldata.page.client =  this.dealerManufacturer;
        digitaldata.page.site = "dc:leadbox:ca";
        digitaldata.page.tool = "event:click to call";
        digitaldata.page.toolDescriptor = "click to call:global";
        digitaldata.page.radUIVersion = window.innerWidth < 768 ? 'ui:rad:mobile' : window.innerWidth < 992 ? 'ui:rad:tablet' : 'ui:rad:pc';
        digitaldata.onclick.onclick = "help:directions";
        digitaldata.onclick.onclickLinkName = "dc:help:directions";
        digitaldata.event.action = "directions|tool";
        digitaldata.user.paCode = this.fordDealerCode;
        typeof (_satellite) !== "undefined" ? _satellite.track("click-to-call") : (function () { console.warn("'_satellite' is not defined"); return null; })();
      }
      else {
        console.warn("Ford Adobe Disabled");
      }
    },
    getTotalInventory(){

      axios.get(window.location.origin+'/wp-content/uploads/data/inventory.json?v='+Date.now())
      .then(response => {
        this.totalInventory = (response && response.data && response.data.vehicles) ? response.data.vehicles.length : 0;
      })
      .catch(() => {
        this.totalInventory = 0;
      });
 
  }
  },
}